import { render } from "./ReviewsSection.vue?vue&type=template&id=14b48ab3&scoped=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"

import "./ReviewsSection.vue?vue&type=style&index=0&id=14b48ab3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b48ab3"]])

export default __exports__